import { FadeUp, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "Time Is The Excuse",
    content:
      "Most workouts get skipped because nobody has a free hour. Fit50 starts at ten minutes — because ten focused minutes, done daily, beat the perfect hour that never happens.",
  },
  {
    number: "02",
    title: "Every Second Programmed",
    content:
      "Warm-ups, work blocks, rest windows and cooldowns are auto-compressed to the exact duration you pick. Intensity scales with your minutes — coaching quality never does.",
  },
  {
    number: "03",
    title: "Progress Measured In Minutes",
    content:
      "Streaks, weekly totals and intensity minutes turn consistency into a scoreboard. Stack ten-minute wins into twenty, thirty, fifty — and watch the compounding take over.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-32 scroll-mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <Eyebrow>The Manifesto</Eyebrow>
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl">
          Three truths we built <span className="text-volt">Fit50</span> on
        </h2>
      </FadeUp>

      <div className="mt-16 border-t border-white/10">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.number} delay={i * 0.1}>
            <div
              data-testid={`manifesto-chapter-${c.number}`}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-12 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-300 px-2 sm:px-4"
            >
              <div className="md:col-span-2">
                <span className="font-display font-black text-6xl sm:text-7xl text-stroke-volt group-hover:text-volt group-hover:[-webkit-text-stroke:0px] transition-all duration-300">
                  {c.number}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display font-extrabold uppercase text-xl sm:text-2xl tracking-normal leading-tight">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-base sm:text-lg text-neutral-400 leading-relaxed">{c.content}</p>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
